/***************************************************************
5/22/2017
Alexander Self
Timesheet View
- Displays timesheets and daily summaries
***************************************************************/
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchTimesheets, downloadTimesheets, fetchMyEmployees, fetchEmployeeTimesheets,
  downloadIndividualTimesheets, fetchMyTimesheets } from '../../../actions';
import Accordion from './timesheet_accordion';
import TimesheetIndividualAccordion from './timesheet_individual_timesheet_accordion';
import TimesheetDownload from './timesheet_download';
//import TimesheetFilters from './timesheet_filters';
import { DatePicker2, AutoComplete } from '../../inputs';
import { getCurrentDate, mapEmployeeForAutoComplete, findEmployeeByName, onDummyComplete } from '../../../utils';

import React, { Component } from 'react';
const $ = window.$;
const Materialize = window.Materialize;

class TimesheetView extends Component {
  constructor(props) {
    super(props);
    this.fetchTSDate = this.fetchTSDate.bind(this);
    this.fetchTSEmployee = this.fetchTSEmployee.bind(this);
    this.fetchMyTimesheetsByDate = this.fetchMyTimesheetsByDate.bind(this);
    this.state = {
      date: getCurrentDate()
    }
  }
  componentDidMount() {
    $(document).ready(() => {
      $('#ts-view').tabs();
    });
    if (this.props.timesheets.length > 0) return;
    this.props.fetchTimesheets(getCurrentDate());
    if (this.props.myEmployees.length > 0) return;
    this.props.fetchMyEmployees(this.props.user.guid);
    if (this.props.myTimesheets.length > 0) return;
  }
  fetchTSDate() { /* Fetches a set of timesheets based on user selected date */
    let date = document.getElementById('view-timesheet-date').value;
    if (date === '') return;
    $('#timesheet-view').fadeOut({ duration: 300 });
    this.props.fetchTimesheets(date);
    this.setState({ date }); // Only local state
    document.getElementById('view-timesheet-date').value = '';
  }
  fetchMyTimesheetsByDate() { /* Fetches a set of timesheets based on user selected date */
    let date = document.getElementById('my-timesheet-date').value;
    if (date === '') return;
    this.props.fetchMyTimesheets(this.props.user.eid, date);
    document.getElementById('my-timesheet-date').value = '';
  }
  fetchTSEmployee() {
    if (document.getElementById('employee-search-ts').value === '') {
      Materialize.toast('Please select an employee', 4000, 'rounded red'); return;
    };
    let emp = findEmployeeByName(document.getElementById('employee-search-ts').value, this.props.employees);
    if (!emp) return;
    this.props.fetchEmployeeTimesheets(emp);
    document.getElementById('employee-search-ts').value = '';
  }
  render() {
    return (
      <div className="row">
        <blockquote><span className="flow-text">View Timesheets</span></blockquote>
        <ul id="ts-view" className="tabs">
          <li className="tab col s6">
            <a href="#all-ts">
              <i className="material-icons">list</i>  All Timesheets
            </a>
          </li>
          <li className="tab col s6">
            <a href="#my-ts" onClick={() => this.props.fetchMyTimesheets(this.props.user.eid)}>
              <i className="material-icons">view_list</i>  My Timesheets
            </a>
          </li>
        </ul>
        <div id="all-ts">
          <div className="col s12 m12 l2">
            <div className="row">
              <DatePicker2 id={'view-timesheet-date'} label={'Select a Date'} />
              <button className="btn waves-effect waves-light" onClick={() => this.fetchTSDate()}>
                Search
              </button>
            </div>
            <div className="row">
              <AutoComplete id={'employee-search-ts'} label={'Select an Employee'}
                data={mapEmployeeForAutoComplete(this.props.employees)}
                onComplete={(val, id) => onDummyComplete(val, id) }
              /> <br />
              <button className="btn waves-effect waves-light" onClick={() => this.fetchTSEmployee()}>
                Search
              </button>
            </div>
            <div className="row">
              <TimesheetDownload id={'ts-download'} _class={'timesheet-download'} label={'Timesheets by Date Range'}
                downloadTimesheets={this.props.downloadTimesheets} email={this.props.user.email} byEmployee={false}
                date1={'ts-download-1'} date2={'ts-download-2'}
              />
              <TimesheetDownload id={'ts-ind-download'} _class={'timesheet-download'} label={'Timesheets by Employee'}
                downloadTimesheets={this.props.downloadIndividualTimesheets} email={this.props.user.email} byEmployee={true}
                employees={this.props.employees} date1={'ts-download-3'} date2={'ts-download-4'}
              />
            </div>
          </div>
          <div className="col s12 m12 l10 emp-list-ts">
            { this.props.timesheets.length < 1 && this.props.employeeTimesheets.timesheets < 1 ? <center><b>No Timesheets Available</b></center> : ''}
            { this.props.timesheets.length < 1 ? ''
              : <div>
                <Accordion id={'timesheet-view'} timesheets={this.props.timesheets} date={this.state.date} />
              </div>
            }
            { this.props.employeeTimesheets.timesheets < 1 ? ''
              : <div>
                <p className="flow-text">{ this.props.employee.firstName } { this.props.employee.lastName }</p><hr />
                <TimesheetIndividualAccordion id={'timesheet-individual-view'}
                  employee={this.props.employee} timesheets={this.props.employeeTimesheets.timesheets}
                />
              </div>
            }
          </div>
        </div>
        <div id="my-ts">
          <blockquote><h5>{ this.props.myTimesheetsDate }</h5></blockquote>
          <div className="col s12 m12 l2">
            <div className="row">
              <DatePicker2 id={'my-timesheet-date'} label={'Select a Date'} />
              <button className="btn waves-effect waves-light" onClick={() => this.fetchMyTimesheetsByDate()}>
                Search
              </button>
            </div>
          </div>
          <div className="col s12 m12 l10 emp-list-ts">
            { this.props.myTimesheets ?
                <div>
                  <Accordion id={'my-timesheet-view'} timesheets={this.props.myTimesheets} date={this.props.myTimesheetDate} />
                </div>
              : <center><b>No Timesheets Available</b></center>
            }
          </div>

        </div>

      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    employees: state.timesheet.employees,
    myEmployees: state.timesheet.myEmployees,
    timesheets: state.timesheet.timesheets,
    myTimesheets: state.timesheet.myTimesheets.timesheets,
    myTimesheetsDate: state.timesheet.myTimesheets.date,
    download: state.timesheet.download,
    employeeTimesheets: state.timesheet.employeeTimesheets,
    employee: state.timesheet.employeeTimesheets.employee
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    downloadIndividualTimesheets,
    downloadTimesheets,
    fetchEmployeeTimesheets,
    fetchMyEmployees,
    fetchMyTimesheets,
    fetchTimesheets
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetView);



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_view.js